module.exports = __webpack_public_path__ + "intro-bg-m.013f773444aa18a9ed31.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/nikolay/Documents/GitHub/menu-web/src/assets/img/intro-bg-m.jpg
// module id = ../../../../../src/assets/img/intro-bg-m.jpg
// module chunks = styles